import { ITEM_PRESETS } from '../content/catalog';
import { addPersonalItem } from './packing-planner';
import { setItemQuantity, setPresetQuantity } from './complete-travel';
import type { Rights } from './entitlement';
import type { PackingState } from './schema';
export interface PackingRow { name: string; quantity: number; ownerHint?: string; presetId?: string; weightG?: number }
export function parsePackingText(text: string): PackingRow[] {
  if (text.length > 20_000) throw new Error('한 번에 20,000자까지 가져와요. 목록을 나눠주세요.');
  let ownerHint: string | undefined;
  return text.split(/[\n,\t]+/).flatMap((raw) => {
    let line = raw.trim().replace(/^\[[^\]]+\]\s*\[(?:오전|오후)?\s*\d{1,2}:\d{2}\]\s*/, '').replace(/^(?:[-•☐□✓✔]+|\d+[.)])\s*/, '').trim();
    const owner = line.match(/^(?:\[([^\]]{1,40})\]|([^:：]{1,40})[:：])\s*(.*)$/);
    if (owner) { ownerHint = (owner[1] ?? owner[2])?.trim(); line = owner[3]!.trim(); }
    if (!line) return [];
    const quantity = line.match(/\s+(?:[xX×]\s*)?(\d+)\s*(?:개|장|벌|켤레)?$/);
    const name = (quantity ? line.slice(0,quantity.index) : line).trim();
    const preset = ITEM_PRESETS.find((row) => row.name === name);
    return [{ name, quantity: quantity ? Number(quantity[1]) : 1, ownerHint, presetId:preset?.id, weightG:preset?.weightG }];
  }).slice(0,200);
}
// The existing shared owner is an unassigned packer, independent of item recipient.
export function resolvePackingRowOwner(state: PackingState, row: PackingRow): string {
  if (row.ownerHint === '공용' || row.ownerHint === 'shared') return 'shared';
  return state.trip.ownerIds.includes(row.ownerHint ?? '') ? row.ownerHint! : 'shared';
}
export function applyPackingRows(state: PackingState, rows: PackingRow[], rights: Rights): PackingState {
  let next = state;
  for (const row of rows) {
    if (!row.name || row.name.length > 80 || !Number.isInteger(row.quantity) || row.quantity < 1) throw new Error('이름은 1~80자, 수량은 1 이상의 정수로 확인해주세요.');
    const owner = resolvePackingRowOwner(state, row);
    const beforeIds = new Set(next.items.map((item) => item.id));
    const preset = ITEM_PRESETS.find((item) => item.id === row.presetId || item.name === row.name);
    const existing = next.items.find((item) => !item.presetId && item.name === row.name);
    if (preset) next = setPresetQuantity(next, preset, next.items.filter((item) => item.presetId === preset.id).length + row.quantity, undefined, rights);
    else if (existing) next = setItemQuantity(next, existing, next.items.filter((item) => !item.presetId && item.name === row.name).length + row.quantity, owner, rights);
    else next = addPersonalItem(next,{name:row.name,quantity:row.quantity,ownerId:owner,weightG:row.weightG},rights);
    next = { ...next, items: next.items.map((item) => beforeIds.has(item.id) ? item : {...item,ownerId:owner}) };
  }
  return next;
}
